import React from 'react';
import { SEO } from '../components/SEO';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon } from 'lucide-react';
export function DatenschutzPage() {
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Privacy Policy',
    url: 'https://close-crm-agentur.de/privacy-policy'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Privacy Policy" description="Privacy Policy of the Close CRM Agency - Information on the handling of personal data." canonical="https://close-crm-agentur.de/privacy-policy" noindex={true} structuredData={structuredData} data-id="element-385" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-386">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-387">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-388">
            <div className="flex items-center justify-center sm:justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-389">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0" aria-label="Close CRM Agency Homepage" data-id="element-390">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-391">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-392">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-393">
                  Close CRM Agency
                </span>
              </a>
              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-394">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-395" />
                Back to Homepage
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-396">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-397">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-398">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-399">
                Privacy Policy
              </h1>

              <div className="space-y-8 text-gray-300" data-id="element-400">
                <section data-id="element-401">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-402">
                    1. Data Protection at a Glance
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-403">
                    General Information
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-404">
                    The following information provides a simple overview of what
                    happens to your personal data when you visit this website.
                    Personal data is any data with which you could be personally
                    identified. Detailed information on the subject of data
                    protection can be found in our privacy policy listed below.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-405">
                    Data Collection on this Website
                  </h3>
                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-406">
                    Who is responsible for the data collection on this website?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-407">
                    The data processing on this website is carried out by the
                    website operator. You can find their contact details in the
                    "Information about the responsible party" section of this
                    privacy policy.
                  </p>

                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-408">
                    How do we collect your data?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-409">
                    Your data is collected when you provide it to us. This
                    could, for example, be data you enter into a contact form.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-410">
                    Other data is collected automatically or after your consent
                    when you visit the website by our IT systems. This data is
                    primarily technical data (e.g. internet browser, operating
                    system, or time of the page request). The collection of this
                    data takes place automatically as soon as you enter this
                    website.
                  </p>

                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-411">
                    What do we use your data for?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-412">
                    Part of the data is collected to ensure the error-free
                    provision of the website. Other data can be used to analyze
                    your user behavior.
                  </p>

                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-413">
                    What rights do you have regarding your data?
                  </h4>
                  <p className="leading-relaxed mb-4" data-id="element-414">
                    You have the right to receive information about the origin,
                    recipient, and purpose of your stored personal data free of
                    charge at any time. You also have the right to request the
                    correction or deletion of this data. If you have given your
                    consent to data processing, you can revoke this consent at
                    any time for the future. Furthermore, you have the right to
                    request the restriction of the processing of your personal
                    data under certain circumstances. You also have the right to
                    lodge a complaint with the competent supervisory authority.
                  </p>
                  <p className="leading-relaxed" data-id="element-415">
                    You can contact us at any time regarding this and other
                    questions on the subject of data protection.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-416">
                    Analysis Tools and Third-Party Tools
                  </h3>
                  <p className="leading-relaxed" data-id="element-417">
                    When visiting this website, your surfing behavior can be
                    statistically evaluated. This happens primarily with
                    so-called analysis programs. Detailed information about
                    these analysis programs can be found in the following
                    privacy policy.
                  </p>
                </section>

                <section data-id="element-418">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-419">
                    2. Hosting
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-420">
                    Webflow
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-421">
                    We host our website with Webflow. The provider is Webflow,
                    Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103,
                    USA (hereinafter Webflow). When you visit our website,
                    Webflow collects various log files including your IP
                    addresses.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-422">
                    Webflow is a tool for creating and hosting websites. Webflow
                    stores cookies or other recognition technologies that are
                    necessary for the display of the page, to provide certain
                    website functions, and to ensure security (necessary
                    cookies).
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-423">
                    For details, please refer to Webflow's privacy policy:{' '}
                    <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-424">
                      https://webflow.com/legal/eu-privacy-policy
                    </a>
                    .
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-425">
                    The use of Webflow is based on Art. 6 para. 1 lit. f GDPR.
                    We have a legitimate interest in the most reliable
                    presentation of our website. If a corresponding consent has
                    been requested, the processing is carried out exclusively on
                    the basis of Art. 6 para. 1 lit. a GDPR and § 25 para. 1
                    TTDSG, insofar as the consent includes the storage of
                    cookies or access to information in the user's end device
                    (e.g., device fingerprinting) within the meaning of the
                    TTDSG. The consent can be revoked at any time.
                  </p>
                  <p className="leading-relaxed" data-id="element-426">
                    Data transmission to the US is based on the Standard
                    Contractual Clauses of the EU Commission. Details can be
                    found here:{' '}
                    <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-427">
                      https://webflow.com/legal/eu-privacy-policy
                    </a>
                    .
                  </p>
                </section>

                <section data-id="element-428">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-429">
                    3. General Notes and Mandatory Information
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-430">
                    Data Protection
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-431">
                    The operators of these pages take the protection of your
                    personal data very seriously. We treat your personal data
                    confidentially and in accordance with the statutory data
                    protection regulations and this privacy policy.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-432">
                    When you use this website, various personal data is
                    collected. Personal data is data with which you can be
                    personally identified. This privacy policy explains what
                    data we collect and what we use it for. It also explains how
                    and for what purpose this happens.
                  </p>
                  <p className="leading-relaxed" data-id="element-433">
                    We would like to point out that data transmission over the
                    Internet (e.g., communication by email) can have security
                    gaps. A complete protection of data against access by third
                    parties is not possible.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-434">
                    Note on the Responsible Party
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-435">
                    The responsible party for data processing on this website
                    is:
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-436">
                    Justus Kraft
                    <br data-id="element-437" />
                    Nebelhornstraße 15
                    <br data-id="element-438" />
                    87435 Kempten
                    <br data-id="element-439" />
                    Phone:{' '}
                    <a href="tel:+491745444423" className="text-[#0ea5e9] hover:underline" data-id="element-440">
                      +49 174 5444423
                    </a>
                    <br data-id="element-441" />
                    Email:{' '}
                    <a href="mailto:jk@justus-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-442">
                      jk@justus-kraft.de
                    </a>
                  </p>
                  <p className="leading-relaxed" data-id="element-443">
                    The responsible party is the natural or legal person who
                    alone or jointly with others decides on the purposes and
                    means of processing personal data (e.g., names, email
                    addresses, etc.).
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-444">
                    Storage Duration
                  </h3>
                  <p className="leading-relaxed" data-id="element-445">
                    Unless a more specific storage period has been specified in
                    this privacy policy, your personal data will remain with us
                    until the purpose for data processing no longer applies. If
                    you assert a legitimate request for deletion or revoke your
                    consent to data processing, your data will be deleted unless
                    we have other legally permissible reasons for storing your
                    personal data (e.g., tax or commercial retention periods);
                    in the latter case, the deletion will take place after these
                    reasons have ceased to apply.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-446">
                    SSL or TLS Encryption
                  </h3>
                  <p className="leading-relaxed" data-id="element-447">
                    For security reasons and to protect the transmission of
                    confidential content, such as orders or inquiries that you
                    send to us as the site operator, this site uses SSL or TLS
                    encryption. You can recognize an encrypted connection by the
                    fact that the address line of the browser changes from
                    "http://" to "https://" and by the lock symbol in your
                    browser line. If SSL or TLS encryption is activated, the
                    data you transmit to us cannot be read by third parties.
                  </p>
                </section>

                <section data-id="element-448">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-449">
                    4. Data Collection on this Website
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-450">
                    Cookies
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-451">
                    Our internet pages use so-called "cookies". Cookies are
                    small text files and do not cause any damage to your end
                    device. They are stored either temporarily for the duration
                    of a session (session cookies) or permanently (permanent
                    cookies) on your end device. Session cookies are
                    automatically deleted at the end of your visit. Permanent
                    cookies remain stored on your end device until you delete
                    them yourself or an automatic deletion is carried out by
                    your web browser.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-452">
                    Contact Form
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-453">
                    If you send us inquiries via the contact form, your details
                    from the inquiry form, including the contact details you
                    provided there, will be stored by us for the purpose of
                    processing the inquiry and in case of follow-up questions.
                    We will not share this data without your consent.
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-454">
                    Inquiry by Email, Telephone, or Fax
                  </h3>
                  <p className="leading-relaxed" data-id="element-455">
                    If you contact us by email, telephone, or fax, your inquiry,
                    including all resulting personal data (name, inquiry), will
                    be stored and processed by us for the purpose of processing
                    your request. We will not share this data without your
                    consent.
                  </p>
                </section>

                <section data-id="element-456">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-457">
                    5. Plugins and Tools
                  </h2>
                  <h3 className="text-xl font-semibold text-white mb-3" data-id="element-458">
                    YouTube
                  </h3>
                  <p className="leading-relaxed mb-4" data-id="element-459">
                    This website embeds videos from the YouTube website. The
                    operator of the website is Google Ireland Limited
                    ("Google"), Gordon House, Barrow Street, Dublin 4, Ireland.
                  </p>
                  <p className="leading-relaxed mb-4" data-id="element-460">
                    Further information on handling user data can be found in
                    YouTube's privacy policy at:{' '}
                    <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-461">
                      https://policies.google.com/privacy?hl=en
                    </a>
                    .
                  </p>

                  <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-462">
                    Google Web Fonts
                  </h3>
                  <p className="leading-relaxed" data-id="element-463">
                    This page uses so-called web fonts provided by Google for
                    the uniform display of fonts. When you call up a page, your
                    browser loads the required web fonts into your browser cache
                    to display texts and fonts correctly.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-464">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-465">
            <p className="text-gray-600 text-sm" data-id="element-466">
              © {new Date().getFullYear()} Close CRM Agency. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}